import { createTranslations } from '../../../i18n/types';

export default createTranslations({
  en: {
    homeTitle: 'RushMid raffle',
    emptyTitle: 'No raffles today',
    rulesButton: 'Rules',
    ticketBadgeLabel: 'Entry',
    yourTicketsLabel: 'Your tickets',
    participantsLabelTop: 'Playing',
    playersOne: 'player',
    playersFew: 'players',
    playersMany: 'players',
    playCta: 'Play',

    detailTitle: 'Raffle',
    backButton: 'Back',
    totalPrizeLabel: 'Total prize',
    totalTicketsLabel: 'Total tickets',
    participantsStatLabel: 'Participants',
    chanceLabel: 'Your win chance',
    participantsSectionTitle: 'Participants',
    participantOne: 'participant',
    participantFew: 'participants',
    participantMany: 'participants',
    showMoreParticipants: 'Show more participants',
    noParticipantsYet: 'No participants yet',

    winnersTitle: 'Winners',
    winnersEmpty: 'No winners yet',
    pastWinnersButton: 'Past winners',

    rulesTitle: 'Raffle rules',
    ruleRowWin: 'Win',
    ruleRowMvp: 'Match MVP',
    ruleRowTriple: '3 kills',
    ruleRowQuad: '4 kills',
    ruleRowAce: '5 kills',
    ruleRowOneHp: 'Win at 1 HP',
    ruleRowClutch2: 'Clutch 1v2',
    ruleRowClutch3: 'Clutch 1v3',
    ruleWinsOnlyTitle: 'Wins only',
    ruleWinsOnlyDescription: 'Tickets are earned only for wins. Matches against bots never award tickets.',
    ruleBurnTitle: 'New raffle every day',
    ruleBurnDescription: 'The winner is drawn at midnight Moscow time, and a fresh raffle starts — tickets only count on the day you earn them.',
    ruleOneChanceTitle: 'More tickets — better odds',
    ruleOneChanceDescription: 'Every ticket is one chance in its entry tier raffle — the more tickets you collect in a day, the higher your odds of taking the prize.',
  },
  ru: {
    homeTitle: 'Розыгрыш RushMid',
    emptyTitle: 'Сегодня розыгрышей нет',
    rulesButton: 'Правила',
    ticketBadgeLabel: 'Взнос',
    yourTicketsLabel: 'Твои билеты',
    participantsLabelTop: 'Участвует',
    playersOne: 'игрок',
    playersFew: 'игрока',
    playersMany: 'игроков',
    playCta: 'Играть',

    detailTitle: 'Розыгрыш',
    backButton: 'Назад',
    totalPrizeLabel: 'Общий приз',
    totalTicketsLabel: 'Всего билетов',
    participantsStatLabel: 'Участников',
    chanceLabel: 'Твой шанс на победу',
    participantsSectionTitle: 'Участники',
    participantOne: 'участник',
    participantFew: 'участника',
    participantMany: 'участников',
    showMoreParticipants: 'Показать ещё участников',
    noParticipantsYet: 'Пока никто не участвует',

    winnersTitle: 'Победители',
    winnersEmpty: 'Победителей пока нет',
    pastWinnersButton: 'Прошлые победители',

    rulesTitle: 'Правила розыгрыша',
    ruleRowWin: 'Победа',
    ruleRowMvp: 'MVP матча',
    ruleRowTriple: '3 кила',
    ruleRowQuad: '4 кила',
    ruleRowAce: '5 килов',
    ruleRowOneHp: 'Победа с 1 HP',
    ruleRowClutch2: 'Клатч 1v2',
    ruleRowClutch3: 'Клатч 1v3',
    ruleWinsOnlyTitle: 'Только победы',
    ruleWinsOnlyDescription: 'Билеты даются только за победы. За игру с ботами билеты не даются.',
    ruleBurnTitle: 'Каждый день — новый розыгрыш',
    ruleBurnDescription: 'В полночь по Москве определяется победитель и стартует новый розыгрыш — билеты действуют только в день, когда ты их получил.',
    ruleOneChanceTitle: 'Больше билетов — выше шанс',
    ruleOneChanceDescription: 'Каждый билет — один шанс в розыгрыше своего взноса: чем больше билетов соберёшь за день, тем выше шанс забрать приз.',
  },
  uz: {
    homeTitle: 'RushMid yutuq o‘yini',
    emptyTitle: 'Bugun yutuq o‘yinlari yo‘q',
    rulesButton: 'Qoidalar',
    ticketBadgeLabel: 'Kirish',
    yourTicketsLabel: 'Sening chiptalaring',
    participantsLabelTop: 'Ishtirok etyapti',
    playersOne: 'o‘yinchi',
    playersFew: 'o‘yinchi',
    playersMany: 'o‘yinchi',
    playCta: "O'ynash",

    detailTitle: "Yutuq o'yini",
    backButton: 'Orqaga',
    totalPrizeLabel: 'Umumiy yutuq',
    totalTicketsLabel: 'Jami chiptalar',
    participantsStatLabel: 'Ishtirokchilar',
    chanceLabel: "G'alaba imkoniyating",
    participantsSectionTitle: 'Ishtirokchilar',
    participantOne: 'ishtirokchi',
    participantFew: 'ishtirokchi',
    participantMany: 'ishtirokchi',
    showMoreParticipants: "Ko'proq ishtirokchilarni ko'rsatish",
    noParticipantsYet: 'Hozircha hech kim ishtirok etmayapti',

    winnersTitle: "G'oliblar",
    winnersEmpty: "Hozircha g'oliblar yo'q",
    pastWinnersButton: "Oldingi g'oliblar",

    rulesTitle: "Yutuq o'yini qoidalari",
    ruleRowWin: 'G‘alaba',
    ruleRowMvp: 'Match MVP',
    ruleRowTriple: '3 ta kill',
    ruleRowQuad: '4 ta kill',
    ruleRowAce: '5 ta kill',
    ruleRowOneHp: '1 HP bilan g‘alaba',
    ruleRowClutch2: 'Clutch 1v2',
    ruleRowClutch3: 'Clutch 1v3',
    ruleWinsOnlyTitle: 'Faqat g‘alabalar',
    ruleWinsOnlyDescription: 'Chiptalar faqat g‘alabalar uchun beriladi. Botlarga qarshi o‘yin uchun chipta berilmaydi.',
    ruleBurnTitle: 'Har kuni yangi yutuq o‘yini',
    ruleBurnDescription: 'Moskva vaqti bilan yarim tunda g‘olib aniqlanadi va yangi o‘yin boshlanadi — chiptalar faqat olingan kunida amal qiladi.',
    ruleOneChanceTitle: 'Chipta ko‘p — imkoniyat yuqori',
    ruleOneChanceDescription: 'Har bir chipta o‘z kirish darajasida bitta imkoniyat beradi — kun davomida chipta qancha ko‘p bo‘lsa, yutish imkoniyati shuncha yuqori.',
  },
});
